import {
  initSaveConsent
} from '../common/api/AuditApi';

// ------ COMPLEX ACTIONS ------ //

export async function saveUserConsent (currentDateTime, access_token, session_token) {
  const response = await initSaveConsent(currentDateTime, access_token, session_token);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(JSON.stringify(data));
  }
  else{
    return data;
  }
}
